import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getTicketDetails } from "../../../api/api";
import styles from "./TicketDetails.module.css";

const TicketDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { customerId, customerName, customerEmail, customerPhone } =
    location.state || {};
  const [customerDetails, setCustomerDetails] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("adminToken");

    if (!token) {
      navigate("/login", {
        state: { error: "Session expired. Please log in again." },
      });
      return;
    }

    if (!customerId) {
      navigate("/dashboard/manage-customer");
      return;
    }

    const fetchCustomerDetails = async () => {
      try {
        const response = await getTicketDetails(customerId);
        const data = response.data;
        setCustomerDetails(data || []);
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    };

    fetchCustomerDetails();
  }, [customerId, navigate]);

  const handleBackClick = () => {
    navigate(-1);
  };

  const prettyStatus = (s = "") => {
    const m = {
      open: "Open",
      in_progress: "In Progress",
      resolved: "Resolved",
      closed: "Closed",
    };
    return m[s.toLowerCase()] || s;
  };

  const isActionDisabled = (s = "") => String(s).toLowerCase() === "closed";

  const isUpdated = (created, updated) => {
    if (!created || !updated) return false;
    return new Date(updated).getTime() - new Date(created).getTime() > 2000;
  };

  const handleViewTicketClick = (ticket) => {
    navigate(`/dashboard/detailed-ticket/${ticket.ticket_id}`, {
      state: { ticket, customerName, customerEmail, customerPhone },
    });
  };

  const actionTitle = (s = "") => {
    const st = String(s).toLowerCase();
    if (st === "closed") return "Ticket is closed";
    if (st === "resolved") return "Open to close this ticket";
    return "View & take action";
  };

  const actionLabel = (s = "") => {
    const st = String(s).toLowerCase();
    if (st === "closed") return "View";
    if (st === "resolved") return "View / Close";
    return "Take Action";
  };

  return (
    <div className={styles.customerDetails}>
      <div className={styles.buttonContainer}>
        <h2>Ticket Details</h2>
        <button className={styles.backButton} onClick={handleBackClick}>
          Back
        </button>
      </div>
      <table className={styles.detailsTable}>
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Subject</th>
            <th>Status</th>
            <th>Last Updated</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {customerDetails.length > 0 ? (
            customerDetails.map((ticket) => (
              <tr key={ticket.ticket_id}>
                <td>{customerName}</td>
                <td>
                  {ticket.subject}
                  {isUpdated(ticket.created_at, ticket.updated_at) && (
                    <span className={styles.updatedPill}>Updated</span>
                  )}
                </td>
                <td>
                  <span
                    className={`${styles.status} ${
                      styles[ticket.status] || ""
                    }`}
                  >
                    {prettyStatus(ticket.status)}
                  </span>
                </td>
                <td>
                  {ticket.updated_at
                    ? new Date(ticket.updated_at).toLocaleString()
                    : "—"}
                </td>
                <td>
                  <button
                    className={styles.viewTicketButton}
                    onClick={() => handleViewTicketClick(ticket)}
                    disabled={isActionDisabled(ticket.status)}
                    title={actionTitle(ticket.status)}
                  >
                    {actionLabel(ticket.status)}
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="">No tickets found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TicketDetails;
